export default "__VITE_ASSET__78230e9e__"